
import _ from 'lodash'

export default {
    props: {
        color: {
            type: String,
            default: 'primary',
        },
        cover: {
            type: Boolean,
            default: false,
        },
        backdrop: {
            type: Boolean,
            default: false,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 32,
        },
        width: {
            type: Number,
            default: 4,
        },
        messages: {
            type: [Array, Boolean],
            default: () => false,
        },
        interval: {
            type: Number,
            default: 2500,
        },
    },
    data () {
        return { intervalId: null, message: null }
    },
    computed: {
        styles () {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
                'border-width': `${this.width}px`,
            }
        },
        spinnerMessages () {
            if (this.messages?.length) {
                return this.messages
            }
            if (this.messages === true) {
                return [
                    'Checking your Medicare benefits...',
                    'Reviewing your healthcare options...',
                    'Consulting with Medicare experts...',
                    'Finding the perfect plan for you...',
                    'Calculating your savings...',
                    'Reviewing Medicare Advantage plans...',
                    'Checking supplement coverage...',
                    'Verifying your eligibility...',
                    'Comparing plan benefits...',
                    'Dotting the i\'s and crossing the t\'s...',
                    'Double-checking those deductibles...',
                    'Ensuring you get the best deal...',
                    'Your agent is working their magic...',
                    'Crunching those healthcare numbers...',
                    'Navigating the Medicare maze...',
                    'Finding your healthcare sweet spot...',
                    'Your perfect plan is loading...',
                ]
            }
            return []
        },
    },
    mounted () {
        this.startMessages()
    },
    destroyed () {
        this.stopMessages()
    },
    methods: {
        selectMessage () {
            this.message = _.sample(this.spinnerMessages)
        },
        startMessages () {
            if (this.spinnerMessages?.length) {
                this.selectMessage()
                this.intervalId = setInterval(this.selectMessage, this.interval)
            }
        },
        stopMessages () {
            clearInterval(this.intervalId)
        },
    },
}
